<template>
<div class="popup" v-cloak v-show="taskSchduleShow" @click="reSet()">
    <div class="content" id="taskListSchdule">
        <div class="title">
            {{$t('language.popup.cloudTransferPopup.schedule')}}
            <div class="icon white-close dialog-close" @click.stop="scheduleClose()"></div>
        </div>
        <div ref="tab" :class="disable?'task-schdule-body-disable':'task-schdule-body'">
            <el-tabs v-model=activeName>
                <el-tab-pane :label="$t('language.popup.daily')" name="first">
                    <tab1 ref="daily" :disable="disable" @changeTabDaily='onChangeTabDaily' @changeDate="changDateValue"></tab1>
                </el-tab-pane>
                <el-tab-pane :label="$t('language.popup.weekly')" name="second">
                    <tab2 ref="weekly" :disable="disable"></tab2>
                </el-tab-pane>
                <el-tab-pane :label="$t('language.popup.monthly')" name="third">
                    <tab3 ref="monthly" :disable="disable"></tab3>
                </el-tab-pane>
            </el-tabs>
            <div class="schedule-footer">
                <span v-if="disable" class="check-scheduled">{{$t('language.popup.cloudTransferPopup.checkScheduled')}}</span>
                <button class="schedule-save" :class="disable?'schedule-save-disable':''" @click.stop="saveSchdule()">{{$t('language.common.save')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import tab1 from "@/components/common/tabs/tabs_transfer_schedule/tab_daily";
import tab2 from "@/components/common/tabs/tabs_transfer_schedule/tab_weekly";
import tab3 from "@/components/common/tabs/tabs_transfer_schedule/tab_monthly";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    components: {
        tab1,
        tab2,
        tab3,
        disable: false
    },
    data: function () {
        return {
            activeName: "first",
            taskSchduleShow: false,
            schedules: {},
            oldSchedules: {},
            times: [],
            weeks: [],
            days: [],
            date: '',
            item: '',
            disable: false,
            flag: true,
            itemIndex: -1,
            oldWeekTimes: [],
            oldMonthlyTimes: [],
            oldOnceTimes: [],
        }
    },
    methods: {
        reSet() {
            this.$refs.daily.$refs.onceDate.checkYear = false;
            this.$refs.daily.$refs.onceDate.checkMonth = false;
            this.$refs.daily.$refs.onceDate.checkDay = false;
            this.$refs.daily.$refs.onceTime.checkMinute = false;
            this.$refs.daily.$refs.onceTime.checkHour = false;
            this.$refs.daily.$refs.dailyTime0.checkMinute = false;
            this.$refs.daily.$refs.dailyTime0.checkHour = false;
            this.$refs.daily.$refs.dailyTime1.checkMinute = false;
            this.$refs.daily.$refs.dailyTime1.checkHour = false;
            this.$refs.daily.$refs.dailyTime2.checkMinute = false;
            this.$refs.daily.$refs.dailyTime2.checkHour = false;
            this.$refs.weekly.$refs.weekTime.checkMinute = false;
            this.$refs.weekly.$refs.weekTime.checkHour = false;
            this.$refs.monthly.$refs.monthTime.checkMinute = false;
            this.$refs.monthly.$refs.monthTime.checkHour = false;
            window.getSelection().empty();
        },
        onChangeTabDaily(value) {
            let type;
            if (this.schedules.type) {
                type = this.schedules.type;
            }
            if (type == 'Once') {
                this.oldOnceTimes = [];
            }
            if (type == 'Monthly') {
                this.oldMonthlyTimes = [];
            }
            if (type == 'Weekly') {
                this.oldWeekTimes = [];
            }
            this.times = value;
        },
        changDateValue(value) {
            this.date = value;
        },
          validatorTime(){
        var timeValue=this.date+' '+this.schedules.times[0];
        var myDate = new Date();
        var now = myDate.valueOf();
        var time = new Date(timeValue).valueOf();
        if(now > time){
            return true;
        }else{
        return false;
        }
        },
        saveSchdule() {
            let that = this;
            let type;
            if (this.schedules.type) {
                type = this.schedules.type;
            }
            //当用户未选择时间类型 校验数据增加抖动
            if (this.activeName == 'first' && type != 'Daily' && type != 'Once') {
                that.$refs.daily.shakeAll = "first-shake";
                setTimeout(() => {
                    that.$refs.daily.shakeAll = "box-shakeOrigin";
                }, 200);
                return false;
            }
            if (type == 'Daily' && !this.times.length) {
                that.$refs.daily.shakeBox = "email-shake";
                setTimeout(() => {
                    that.$refs.daily.shakeBox = "box-shakeOrigin";
                }, 200);
                return false;
            }
            if (this.activeName == 'second' && !this.weeks.length) {
                that.$refs.weekly.shakeBox = "box-shakeY ";
                setTimeout(() => {
                    that.$refs.weekly.shakeBox = "box-shakeYOrigin";
                }, 200);
                return false;
            }
            if (this.activeName == 'third' && !this.$refs.monthly.monthArr.length) {
                that.$refs.monthly.shakeBox = "box-shakeNumber ";
                setTimeout(() => {
                    that.$refs.monthly.shakeBox = "box-shakeYOrigin";
                }, 200);
                return false;
            }
            this.schedules = {};
            this.$parent.checkedSchedule = true;
            if (type == 'Once' && this.date) {
                this.schedules.date = this.date;
            }
            if (this.days.length) {
                let days = [];
                $.each(this.days, function (dayIndex, dayItem) {
                    dayItem=parseInt(dayItem);
                    if (dayItem != null && dayItem != undefined && dayItem != "" && !window.isNaN(dayItem)) {
                        days.push(dayItem);
                    }
                    if (dayItem == 0) {
                        days.push(dayItem);
                    }
                });
                this.schedules.days = Object.assign([], days);
            }
            if (this.weeks.length) {
                let weeks = [];
                $.each(this.weeks, function (weekIndex, weekItem) {
                    if (weekItem != null && weekItem != undefined && weekItem != "" && !window.isNaN(weekItem)) {
                        weeks.push(parseInt(weekItem));
                    }
                    if (weekItem == 0) {
                        weeks.push(weekItem);
                    }
                });
                this.schedules.weeks = Object.assign([], weeks);
            }
            if (this.oldWeekTimes.length && type == 'Weekly') {
                this.schedules.times = this.oldWeekTimes;
            } else if (this.oldMonthlyTimes.length && type == 'Monthly') {
                this.schedules.times = this.oldMonthlyTimes;
            } else if (this.oldOnceTimes.length && type == 'Once') {
                this.schedules.times = this.oldOnceTimes;
            } else {
                this.schedules.times = this.times;
            }
            this.schedules.type = type;
              if( this.schedules.type == 'Once' &&this.validatorTime()){
                        that.$toast({
                        text: that.$t('language.teamTransfer.timePassed'),
                         type: 'fail',
                        idValue: "allBox"
                   });
                  return false;
                  }
            this.updateOptionRequest();
        },
        updateOptionRequest() {
            //可以进行定时计划任务执行时，提示需要付费才能使用
            if (!commonUtils.getUser().vip) {
                this.$parent.$parent.$refs.upgradeDialog.upgradeShow = true;
                this.$parent.$parent.$refs.upgradeDialog.reset();
                this.$parent.$parent.$refs.upgradeDialog.scheduledShow = true;
                return false;
            }
            let that = this;
            var updateData;
            let schedules = this.schedules;
            schedules.clientTime = commonUtils.getNowDateFormat();
            let options = this.item.options;
            let itemData = this.item;
            let getData;
            if (this.flag) {
                this.flag = false;
                if (this.item.groupId) {
                    let gd = this.item.groupId;
                    updateData = {
                        gd: gd,
                        ud: commonUtils.getUser().id,
                        type: this.item.type,
                        n: this.item.name,
                        options: options,
                        schedules: schedules
                    }
                } else {
                    let id = this.item.id;
                    updateData = {
                        id: id,
                        ud: commonUtils.getUser().id,
                        type: this.item.type,
                        n: this.item.name,
                        options: options,
                        schedules: schedules
                    }
                }
                that.taskSchduleShow = false;
                that.$parent.tasklistData[that.itemIndex].updateFlag = true;
                that.$parent.$forceUpdate();
                if(this.item.branchType != 'businessTransfer'){
                this.Utils.doTasksRequest("update", updateData).then(result => {
                    if (result.status == 200) {
                        if (itemData.groupId) {
                            getData = {
                                ud: commonUtils.getUser().id,
                                type: itemData.type,
                                gd: itemData.groupId
                            }
                        } else {
                            getData = {
                                ud: commonUtils.getUser().id,
                                type: itemData.type,
                                id: itemData.id,
                            }
                        }
                        that.Utils.doTasksRequest("get", getData).then(res => {
                            that.flag = true;
                            let data = that.$parent.tasklistData[that.itemIndex];
                            data.schedules = res.tasks[0].schedules;
                            data.options = options;
                            that.$parent.clearTime(that.itemIndex);
                            that.$parent.getTimedExecution();
                            that.$parent.tasklistData[that.itemIndex].updateFlag = false;
                            that.$parent.$forceUpdate();
                        });
                    } else {
                        that.$parent.tasklistData[that.itemIndex].updateFlag = false;
                        that.$parent.$forceUpdate();
                        this.$toast({
                            text: this.$t('language.exception.' + result.reason),
                            type: 'fail',
                            idValue: "rightBodyList"
                        });
                    }
                 });
               }else{
                     delete updateData.type;
                     this.Utils.doBusinessTransferRequest("update", updateData).then(result => {
                          let data = that.$parent.tasklistData[that.itemIndex];
                             data.schedules = schedules;
                             data.options = options;
                             if(data.sources){
                             for(var i=0;i<data.sources.length;i++){
                              data.sources[i].options=options;
                              data.sources[i].schedules=schedules;
                            }
                          }
                           that.$parent.clearTime(that.itemIndex);
                           that.$parent.getTimedExecution();
                           that.$parent.tasklistData[that.itemIndex].updateFlag = false;
                           that.$parent.$forceUpdate();
                     }).catch(err =>{
						 if (err.reason) {
						   err = that.$t('language.exception.' + err.reason)
						 }
						 that.$parent.tasklistData[that.itemIndex].updateFlag = false;
						 that.$parent.$forceUpdate();
						 that.$toast({
						     text:err,
						     type: 'fail',
						     idValue: "rightBodyList"
						 });
					 });
               }
            }
        },
        scheduleClose() {
            this.taskSchduleShow = false;
        },
        keepTabDailyData() {
            this.$refs.weekly.weekArr = [];
            this.$refs.monthly.monthArr = [];
        },
        keepTabWeeklyData() {
            this.$refs.daily.checkArr = [];
            this.$refs.daily.dailyTimeArr = [];
            this.$refs.daily.dailyDisableFlage = true;
            this.$refs.daily.onceDisableFlage = true;
            this.$refs.monthly.monthArr = [];
        },
        keepTabMonthlyData() {
            this.$refs.daily.checkArr = [];
            this.$refs.daily.dailyTimeArr = [];
            this.$refs.daily.dailyDisableFlage = true;
            this.$refs.daily.onceDisableFlage = true;
            this.$refs.weekly.weekArr = [];
        },
        checkDisable() {
            this.disable = !this.disable;
            if (this.disable) {

            }
        }
    },
}
</script>

<style>
#taskListSchdule #tab-first,
#taskListSchdule #tab-second,
#taskListSchdule #tab-third {
    font-size: 14px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 40px;
    /*no*/
    position: relative;
    top: -3px;
    /*no*/
}

#taskListSchdule {
    width: 680px;
    /*no*/
    height: 440px;
    /*no*/
}

.task-schdule-body {
    width: 100%;
    height: 400px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20px 20px 20px;
    /*no*/
}

.task-schdule-body-disable {
    width: 100%;
    height: 400px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20px 20px 20px;
    /*no*/
    pointer-events: none;
}

.schedule-content {
    width: 100%;
    height: 300px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: #6f7886;
    box-sizing: border-box;
    padding-top: 30px;
    /*no*/
    position: relative;
    margin: auto;
}

.disable-schedule {
    font-size: 14px;
    /*no*/
    color: #6f7886;
    position: relative;
    top: 16px;
    /*no*/
    left: 18px;
    /*no*/
    float: left;
}

.disable-box-position {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;

}

.check-scheduled {
    font-size: 14Px;
    position: absolute;
    top: -35Px;
}

#taskListSchdule .el-tabs__content {
    height: 300px;
    /*no*/
    position: relative;
    width: 100%;
    font-size: 14px;
    /*no*/
    color: #6f7886;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 30px;
    /*no*/
}

.schedule-save-disable {
    background: #c8d1f7;
}

.task-schdule-body-disable .is-active {
    color: #c8d1f7 !important;
}

 .el-tabs__item:focus.is-active.is-focus:not(:active) {
    -webkit-box-shadow: none;
    box-shadow: none;
}

.task-schdule-body-disable .el-tabs__active-bar {
    background: #c8d1f7 !important;
}

/* .task-schdule-body-disable #tab-second,
.task-schdule-body-disable #tab-third {
    color: #c8d1f7 !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/task_list_schedule_popup.vue